import alias from '../assets/alias.png'

function EmployeeAlias(props) {
    
    // props.position.charAt(0).toLocaleUpperCase();

    return(
        <div className='cursor-pointer bg-white rounded-lg p-6 shadow-md'>
            <div className='flex justify-center'>
                <div className='rounded-full px-6 mb-4'><img src={alias} className='w-32 h-32 rounded-full' /></div>
            </div>
            <div className='pt-4 pb-1 px-4 rounded-md '>
                <div className='flex justify-center text-xs font-semibold py-2' >{props.name}</div>
                <div className='flex justify-center text-xs text-gray-800'>{props.position}</div>
            </div>
        </div>
    )
}

export default EmployeeAlias;